// PR-30: WeChat in-app browser detection.
//
// Shared links opened inside WeChat (微信) load in its own embedded WebView,
// which lacks beforeinstallprompt and aggressively caches HTML. We surface
// a one-line tip suggesting users open in a real browser, and don't try
// to install-prompt them.
export function isWeChatWebView(): boolean {
  if (typeof navigator === 'undefined') return false
  return /MicroMessenger/i.test(navigator.userAgent)
}
